import { StripeService } from "@/common/api.service";
import { FETCH_STRIPE_SECRET_KEY, SET_STRIPE_CARD, DELETE_CARD, FETCH_STRIPE_ALL_CARDS, STRIPE_RESET_STATE,FETCH_INVOICES, AUTO_RENEWAL_OFF} from "./actions.type";
import { SET_STRIPE_SECRET_KEY, SET_STRIPE_ALL_CARDS, SET_INVOICES, RESET_STRIPE_STATE ,SET_RESPONSE } from "./mutations.type";


const initialState = () =>{
    return {
        stripesecretkey: [],
        stripeallcard: null,
        response: null,    
        invoices: null,
    }
} ;


export const state = initialState();

const getters = {
    stripesecretkey(state) {
        return state.stripesecretkey;
    },
    stripeallcards(state){
        return state.stripeallcard
    },
    invoices(state){
        return state.invoices
    }    
};

const actions = {
    async [FETCH_STRIPE_SECRET_KEY](context,slug) {
        const { data } = await StripeService.get(slug);
        context.commit(SET_STRIPE_SECRET_KEY, data.data.client_secret);
        return data;
    },
    async [SET_STRIPE_CARD](context,params) {
        const { data } = await StripeService.saveCard(params);
        context.commit(SET_RESPONSE, data);
        return data;
    },
    async [FETCH_STRIPE_ALL_CARDS](context,slug) {
        const { data } = await StripeService.get(slug);
        context.commit(SET_STRIPE_ALL_CARDS, data.data);
        return data;
    },
    async [FETCH_INVOICES](context,slug) {
        const { data } = await StripeService.get(slug);
        context.commit(SET_INVOICES, data.data);
        return data; 
    },      
    async [AUTO_RENEWAL_OFF](context,slug) {
        const { data } = await StripeService.renewoff(slug);
        context.commit(SET_RESPONSE, data.data);
        return data; 
    },     
    async [DELETE_CARD] (context, slug) {
        return StripeService.get(slug)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_RESPONSE, error.response.data.errors);
        });
    },    
    [STRIPE_RESET_STATE]({ commit }) {
        commit(RESET_STRIPE_STATE);
    }        
};


const mutations = {
    [SET_STRIPE_SECRET_KEY](state, stripekey) {
        state.stripesecretkey = stripekey;
    },
    [SET_STRIPE_ALL_CARDS](state, cards) {
        state.stripeallcard = cards;
    },    
    [SET_RESPONSE](state, response) {
        state.response = response;
    },
    [SET_INVOICES](state, invoices) {
        state.invoices = invoices;
    },  
    [RESET_STRIPE_STATE]() {
        Object.assign(state, initialState())
    }           
};


export default {
    state,
    getters,
    actions,
    mutations
};